import { gsap, ScrollTrigger } from "gsap/all";

export function teaserInteractive() {
  gsap.registerPlugin(ScrollTrigger);
  const animationDuration = 0.8;
  const animationDelay = 0.5;
  const staggerDelay = 0.15;
  const startPosition = "top 80%";

  // Reset animations delay & stagger inside each block
  const blocks = document.querySelectorAll(".gutenberg-content > .gutenberg-block");

  blocks.forEach((block) => {
    const elements = block.querySelectorAll(".teaser-element-wrapper");

    // Only animate if elements exist
    if (elements.length === 0) return;

    // Animation
    gsap.to(elements, {
        duration: animationDuration,
        delay: animationDelay,
        stagger: {
            each: staggerDelay,
            onStart: function() {
                this.targets()[0].classList.add('animated');
            }
        },
        scrollTrigger: {
            trigger: block,
            start: startPosition,
            // markers: true,
        }
    });
  });
}